import { EnumSchema } from '../metadata-schema';

export const Examenstatus: EnumSchema = {
	"type": "string",
	"title": "Examenstatus",
	"enum": [
		"Geslaagd",
		"Afgewezen",
		"Voortijdig teruggetrokken",
		"Overig",
		"Tijdens examen teruggetrokken",
		"Voorlaatste jaar",
		"Gespreid examen",
		"Aangemeld"
	]
};
